import store from 'store';

export function getNextProgressStep() {
  const { allSteps } = store.getState().progress;
  const route = window.location.pathname;
  const activeRoute = route.search('gender/') < 0 ? route : route.replace(/(\/\d)/g, '');
  return allSteps.map(item => item.route).indexOf(activeRoute);
}